import React from "react";
import PropTypes from "prop-types";

//
import Moment from "react-moment";

//
import ImageBox from "../../../general/ImageBox";

//
import User from "../../../../assets/img/user.png";

function MobileInvitationList({ items }) {
  return (
    <div className="box-type">
      {items.map((item) => (
        <div className="items">
          <header>
            <p className="img-name">
              <img src={User} alt="user" className="rounded-full" />
              <span>{item.email}</span>
            </p>

          </header>
          <div className="content zebra">
            <div className="item">
              <p>Date Signed Up</p>
              <p>
                <span className="fw-bolder">
                  <Moment utc format="MMM DD, YYYY, ">{item.created_at}</Moment>
                </span>
                <span>
                  <Moment utc format="hh:mm">{item.created_at}</Moment>
                </span>
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

MobileInvitationList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default MobileInvitationList;
